// Vue Router 4 drops the query from { path: '/a?b=1' }, so push a path-only location as a string.
export function toRouterLocation(routeObj) {
  const { path, ...rest } = routeObj;
  if (typeof path === 'string' && !Object.keys(rest).length) {
    return path;
  }
  return routeObj;
}

// Vue Router 4 resolves relative redirects against the current URL, so prefix the parent path.
export function withAbsoluteRedirects(routes, basePath) {
  return routes.map((route) => {
    const routePath = route.path?.startsWith('/') ? route.path : `${basePath}/${route.path ?? ''}`;
    const redirect = typeof route.redirect === 'string' && !route.redirect.startsWith('/')
      ? `${basePath}/${route.redirect}`
      : route.redirect;
    const children = route.children && withAbsoluteRedirects(route.children, routePath.replace(/\/$/, ''));
    return { ...route, redirect, ...(children && { children }) };
  });
}
